import { Link } from 'react-router-dom'
import { useRef } from 'react'
import Switch from './Switch'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBarsStaggered } from '@fortawesome/free-solid-svg-icons'

function Header() {
    let navRef = useRef(null)

    function closeMenu() {
        navRef.current.classList.remove('show')
    }
    
    function handleClick() {
        if (navRef.current.classList.contains('show')) {
            closeMenu()
        } else {
            navRef.current.classList.add('show')
        }
    }

    return (
        <header>
            <div className='headerWrap'>
                <div className='mobile'>
                    <div className='handle' onClick={handleClick}>
                        <FontAwesomeIcon icon={faBarsStaggered} size='2x' />
                    </div>
                </div>
                <nav ref={navRef}>
                    <Link to='/' className='siteName'>
                        ColinWeb.Dev{' '}
                    </Link>
                    <Link to='/' onClick={closeMenu}>Home </Link>
                    <Link to='/portfolio' onClick={closeMenu}>Portfolio</Link>
                    <Link to='/blog' onClick={closeMenu}>Blog</Link>
                    <Link to='/about' onClick={closeMenu}>About</Link>
                    <Link to='/contact' onClick={closeMenu}>Contact</Link>
                </nav>
                <Switch />
            </div>
        </header>
    )
}

export default Header
